import { ReactNode } from "react";

import { twMerge } from "tailwind-merge";

type Props = {
  icon?: ReactNode;
  description?: string;
  className?: string;
};

const EmptyPlaceholder = ({ icon, description, className }: Props) => {
  return (
    <div
      className={twMerge(
        "flex flex-col items-center justify-center bg-white-smoke rounded-md py-3 px-4",
        className
      )}
    >
      {icon}
      <p className="text-center text-txtPlaceholder">{description}</p>
    </div>
  );
};

export default EmptyPlaceholder;
